// Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from 'src/app/shared/shared.module';
import { EcashModule } from 'src/app/modules/ecash/ecash.module';
// Pages
import { RegistrationEntryPageComponent } from './pages/registration-entry-page/registration-entry-page.component';
import { RegistrationSuccessPageComponent } from './pages/registration-success-page/registration-success-page.component';
import { RegistrationPaymentCallbackPageComponent } from './pages/registration-payment-callback-page/registration-payment-callback-page.component';
// Shared
import { RegistrationNavigationComponent } from './components/registration-navigation/registration-navigation.component';
// Steps
import { RegistrationFailurePageComponent } from './pages/registration-failure-page/registration-failure-page.component';

import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { TermsAndConditionsModule } from '@fgb/portal-component-library/src/lib/club/terms-and-conditions';

@NgModule({
  declarations: [
    RegistrationEntryPageComponent,
    RegistrationSuccessPageComponent,
    RegistrationNavigationComponent,
    RegistrationPaymentCallbackPageComponent,
    // Steps
    RegistrationFailurePageComponent,
  ],
  imports: [
    NgbModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: function HttpLoaderFactory(http: HttpClient) {
          return new TranslateHttpLoader(http, './assets/i18n/', '.json');
        },
        deps: [HttpClient],
      },
    }),
    SharedModule,
    EcashModule,
    TermsAndConditionsModule,
  ],
  exports: [RegistrationEntryPageComponent, RegistrationSuccessPageComponent],
})
export class RegistrationModule {}
